import styled from 'styled-components';

export const DashContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  margin-bottom: 1rem;
`;

export const CompareContent = styled.div`
  display: grid;
  grid-template-columns: 35% 65%;
  gap: 1rem;
  height: 100%;
`;

export const ChartsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
